const Layout = () => import('@/layout/index.vue')

export default {
    path: '/records',
    component: Layout,
    redirect: '/records/account',
    name: 'Records',
    meta: {
        title: '记录流水',
        icon: 'records'
    },
    children: [
        {
            path: 'account',
            name: 'RecordsAccount',
            component: () => import('@/views/records/account/index.vue'),
            meta: {
                title: '账号信息',
                icon: 'account',
                auth: ['records.account']
            }
        },
        {
            path: 'user',
            name: 'RecordsUser',
            component: () => import('@/views/records/user/index.vue'),
            meta: {
                title: '用户数据',
                icon: 'records-user',
                auth: ['records.user']
            }
        },
        {
            path: 'shop',
            name: 'RecordsShop',
            component: () => import('@/views/records/shop/index.vue'),
            meta: {
                title: '授权店铺',
                icon: 'records-shop',
                auth: ['records.shop']
            }
        },
        {
            path: 'statistics',
            name: 'RecordsStatistics',
            component: () => import('@/views/records/statistics/index.vue'),
            meta: {
                title: '统计计数',
                icon: 'records-statistics',
                auth: ['records.statistics']
            }
        },
        {
            path: 'verify',
            name: 'RecordsVerify',
            component: () => import('@/views/records/verify/index.vue'),
            meta: {
                title: '验证记录',
                icon: 'verify',
                auth: ['records.verify']
            }
        },
        {
            path: 'order',
            name: 'RecordsOrder',
            component: () => import('@/views/records/order/index.vue'),
            meta: {
                title: '用户订单',
                icon: 'order',
                auth: ['records.order']
            }
        },
        {
            path: 'packageOrder',
            name: 'RecordsPackageOrder',
            component: () => import('@/views/records/packageOrder/index.vue'),
            meta: {
                title: '套餐订单',
                icon: 'records-package-order',
                auth: ['records.packageOrder']
            }
        },
        {
            path: 'interface',
            name: 'RecordsInterface',
            component: () => import('@/views/records/interface/index.vue'),
            meta: {
                title: '接口记录',
                icon: 'interface',
                auth: ['records.interface']
            }
        },
        {
            path: 'score',
            name: 'RecordsScore',
            component: () => import('@/views/records/score/index.vue'),
            meta: {
                title: '积分记录',
                icon: 'score',
                auth: ['records.score']
            }
        },
        {
            path: 'invitation',
            name: 'RecordsInvitation',
            component: () => import('@/views/records/invitation/index.vue'),
            meta: {
                title: '邀请记录',
                icon: 'invitation',
                auth: ['records.invitation']
            }
        },
        {
            path: 'included',
            name: 'RecordsIncluded',
            component: () => import('@/views/records/included/index.vue'),
            meta: {
                title: '收录审核',
                icon: 'records-included',
                auth: ['records.included']
            }
        },
        {
            path: 'coupon',
            name: 'RecordsCoupon',
            component: () => import('@/views/records/coupon/index.vue'),
            meta: {
                title: '优惠券记录',
                icon: 'records-coupon',
                auth: ['records.coupon']
            }
        }
    ]
}
